var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ListContactsWithStartedProspection, markAnswered, markFollowUp, } from '@/clients/llm';
import { companyFields, decisorFields } from '@/shared/utils/translate';
import { Component, Prop, Vue } from 'vue-property-decorator';
let FollowUp = class FollowUp extends Vue {
    constructor() {
        super(...arguments);
        this.channel = 'whatsapp';
        this.first_contact_from_days = null;
        this.first_contact_before_days = null;
        this.last_contact_from_days = null;
        this.last_contact_before_days = null;
        this.business_days = false;
        this.contacts = [];
        this.total = 0;
    }
    mounted() {
        this.infoSetId = this.$route.params.infoSetId;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.infoSetId = this.$route.params.infoSetId;
        this.channel = urlParams.get('canal') || 'whatsapp';
        const first_contact_from_days = urlParams.get('primeiro-contato-em-dias');
        if (first_contact_from_days) {
            this.first_contact_from_days = +first_contact_from_days;
        }
        const first_contact_before_days = urlParams.get('primeiro-contato-antes-de-dias');
        if (first_contact_before_days) {
            this.first_contact_before_days = +first_contact_before_days;
        }
        const last_contact_from_days = urlParams.get('ultimo-contato-em-dias');
        if (last_contact_from_days) {
            this.last_contact_from_days = +last_contact_from_days;
        }
        const last_contact_before_days = urlParams.get('ultimo-contato-antes-de-dias');
        if (last_contact_before_days) {
            this.last_contact_before_days = +last_contact_before_days;
        }
        const business_days = urlParams.get('dias-uteis');
        if (business_days) {
            this.business_days = business_days == 'sim';
        }
        this.ListContactsWithStartedProspection();
    }
    async ListContactsWithStartedProspection() {
        try {
            const response = await ListContactsWithStartedProspection(this.infoSetId, this.channel, {
                first_contact_from_days: this.first_contact_from_days,
                first_contact_before_days: this.first_contact_before_days,
                last_contact_from_days: this.last_contact_from_days,
                last_contact_before_days: this.last_contact_before_days,
                business_days: this.business_days,
            }, this.page, this.limit);
            this.contacts = response.data.contacts.map(contact => {
                return {
                    ...companyFields(contact),
                    ...decisorFields(contact.decisor),
                    whatsapp: contact.whatsapp,
                    linkedin: contact.linkedin,
                    email: contact.email,
                    'último follow up': contact.last_follow_up_at || contact.last_fallow_up_at,
                    'primeiro contato': contact.created_at,
                };
            });
            this.total = response.data.total;
        }
        catch (e) {
            console.log(e);
        }
    }
    async markFollowUp(contact) {
        try {
            await markFollowUp(this.infoSetId, contact['id da empresa'], this.channel, contact[this.channel]);
            this.ListContactsWithStartedProspection();
        }
        catch (e) {
            console.log(e);
        }
    }
    async markAnswered(contact) {
        try {
            await markAnswered(this.infoSetId, contact['id da empresa'], this.channel, contact[this.channel]);
            this.ListContactsWithStartedProspection();
        }
        catch (e) {
            console.log(e);
        }
    }
    getBtnClass(contact) {
        return `${contact['id da empresa']}-${contact[this.channel]}`;
    }
};
__decorate([
    Prop({ default: () => 'json' })
], FollowUp.prototype, "format", void 0);
__decorate([
    Prop({ default: () => 1 })
], FollowUp.prototype, "page", void 0);
__decorate([
    Prop({ default: () => 10 })
], FollowUp.prototype, "limit", void 0);
FollowUp = __decorate([
    Component({
        name: 'FollowUp',
        components: {},
    })
], FollowUp);
export default FollowUp;
